module.exports = __webpack_public_path__ + "static/img/qt_6.950b191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/qt_6.png
// module id = VhQo
// module chunks = 1